import last from 'lodash/last';
import uniq from 'lodash/uniq';

function forceUpdateSelectedItem({ sortedItemsUuids, lastSelected, uuid, newSelectedUuids }) {
  const firstSelectedIndex = sortedItemsUuids.indexOf(lastSelected);
  const lastSelectedIndex = sortedItemsUuids.indexOf(uuid);
  if (firstSelectedIndex > lastSelectedIndex) {
    for (let i = firstSelectedIndex; i >= lastSelectedIndex; i -= 1) newSelectedUuids.push(sortedItemsUuids[i]);
  } else {
    for (let i = firstSelectedIndex; i <= lastSelectedIndex; i += 1) newSelectedUuids.push(sortedItemsUuids[i]);
  }
  return newSelectedUuids;
}

export function updateSelectedItem(
  selectedUuids,
  { uuid, params: { isOneSelected, isMetaPressed, isShiftPressed } },
  sortedItemsUuids,
  sortedDiscussionTopicsUuids
) {
  // If the shift is pressed then add all items from the last selected to the clicked one
  if (uuid && isShiftPressed) {
    // TODO: handle discussion topics in this scenario
    const allSortedUuids = sortedDiscussionTopicsUuids.concat(sortedItemsUuids);
    const lastSelected = last(selectedUuids);
    return uniq(
      forceUpdateSelectedItem({
        sortedItemsUuids: allSortedUuids,
        lastSelected,
        uuid,
        newSelectedUuids: Array.from(selectedUuids),
      })
    );
  }
  // if the flag isOneSelected then return an array with one selected item
  if (uuid && isOneSelected) return [uuid];
  // If the metaKey is pressed and the selected element is already in the array selectedUuids then remove the element from the array.
  if (uuid && isMetaPressed && selectedUuids.includes(uuid))
    return selectedUuids.filter(selectedUuid => selectedUuid !== uuid);
  // If no parameters are passed just add an element to the end of the array
  if (uuid) return [...selectedUuids, uuid];
  // If the uuid was not passed clear the array
  return [];
}

const selectedUuids = (state = [], action) => {
  switch (action.type) {
    case 'UPDATE_SELECTED_ITEMS':
      return updateSelectedItem(
        state,
        action.payload,
        action.sortedActionItemsUuids,
        action.sortedDiscussionTopicsUuids
      );
    case 'CLEAR_SELECTED_ITEMS':
      return [];
    default:
      return state;
  }
};

export default selectedUuids;
